import PolicyEndorsementProvider from '../providers/policy-endorsement-provider';

class PolicyEndorsementRepository {

    constructor() {
        this.policyEndorsementProvider = new PolicyEndorsementProvider();
    }

    getValidarEndosoPoliza = async (validarEndosoPoliza) => {
        return this.policyEndorsementProvider.getValidarEndosoPoliza(validarEndosoPoliza);
    }

}

export default PolicyEndorsementRepository;